import { render } from "./EchoContent.vue?vue&type=template&id=9fd675c4&scoped=true"
import script from "./EchoContent.vue?vue&type=script&lang=js"
export * from "./EchoContent.vue?vue&type=script&lang=js"

import "./EchoContent.vue?vue&type=style&index=0&id=9fd675c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fd675c4"]])

export default __exports__